import { Button, FormControlLabel, FormGroup, FormHelperText, Grid, InputAdornment, TextField } from "@mui/material";
import React, { useState } from "react";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import {
    ProductBlockContainer,
    StyledButtonAddToShoppingCard,
    StyledCurrency,
    StyledMenuItem,
    StyledSection,
    StyledTypography,
    StyledTypographyPrice,
    WrapperSectionContent
} from "@features/shared/ProductBlock/styledComponents";
import Typography from "@mui/material/Typography";
import { useTheme } from "@mui/material/styles";
import Checkbox from "@mui/material/Checkbox";
import { calculateTotalPrice } from "@helper/utils";
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import { useDispatch } from 'react-redux';
import { addItem } from '../../../services/reducers/basketSlice';
import { StyledTypographyFilter } from "@features/shared/styledComponents";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useLocation, useNavigate } from "react-router-dom";
import {TextFieldInput, TextFieldInputCount, TextFieldSelect} from "@features/shared/ProductBlock/shared";

export const ProductBlock = ({ product }) => {
    const theme = useTheme();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { state } = useLocation();

    const [isLoading, setIsLoading] = useState(false);
    const [selectedWidth, setSelectedWidth] = useState(product.price[0].width);
    const [selectedLength, setSelectedLength] = useState(300);
    const [lengthError, setLengthError] = useState(false);
    const [currentPrice, setCurrentPrice] = useState(product.price[0].price);
    const [additionalPriceChecked, setAdditionalPriceChecked] = useState([]);
    const [buttonText, setButtonText] = useState("Додати в кошик");
    const [selectedCounts, setSelectedCounts] = useState(product?.additionalPrice?.map(() => 1));


    const handleCountChange = (event, index) => {
        const value = event.target.value;
        const newCounts = [...selectedCounts];
        newCounts[index] = value;
        setSelectedCounts(newCounts);
    };

    const handleWidthChange = (event) => {
        setSelectedWidth(event.target.value);
        const selectedPrice = product.price.find(
            (price) => price.width === event.target.value
        );
        if (selectedPrice) {
            setCurrentPrice(selectedPrice.price);
        }
    };

    const from = state?.from || '/mosquitoNets';

    const handleBackToList = () => navigate(from);

    const handleLengthChange = (event) => {
        if (event.target.value >= 300 && event.target.value <= 6000) {
            setLengthError(false);
        } else {
            setLengthError(true);
        }
        setSelectedLength(event.target.value);
    };

    const handleChangeAdditionalPrice = (event) => {
        const additionalPriceObject = product.additionalPrice.find(item => item._id === event.target.name);

        if (event.target.checked) {
            setAdditionalPriceChecked([...additionalPriceChecked, additionalPriceObject]);
        } else {
            setAdditionalPriceChecked(additionalPriceChecked.filter(item => item._id !== event.target.name));
        }
    };

    const getSelectedLengthError = lengthError => lengthError < 300 ?
        "мінімальна довжина 300 міліметрів" :
        "максимальна довжина 6000 міліметрів";

    const handleButtonClick = () => {
        const uniqueId = `${product._id}_${new Date().getTime()}`;

        const item = {
            uniqueId,
            id: product._id,
            img: product.image.url,
            name: product.name,
            quantity: 1,
            selectedLength,
            selectedWidth,
            additionalPriceChecked,
            finalPrice: calculateTotalPrice(currentPrice, selectedLength, additionalPriceChecked),
        }

        if (buttonText === 'Оформити замовлення') {
            navigate('/basket');
        } else {
            setIsLoading(true);
            setTimeout(() => {
                dispatch(addItem(item));
                setIsLoading(false);
                setButtonText("Оформити замовлення");
            }, 1000);
        }
    };

    const allVariantsAreNone = (config) => config.every(item => item.variant === "None");
    const isMainState = buttonText === 'Додати в кошик';

    return (
        <ProductBlockContainer container spacing={2}>
            <Grid item xl={4} lg={5} md={12} sm={12}>
                <img
                    src={`${product?.image?.url}`}
                    alt={product.title}
                    loading="lazy"
                    width="100%"
                />
            </Grid>
            <Grid item xl={8} lg={7} md={12} sm={12}>
                <StyledTypography as="h2">{product.name}</StyledTypography>
                {!allVariantsAreNone(Object.values(product.config)) && <>
                    <StyledSection item xs={12}>Характеристики</StyledSection>
                    <WrapperSectionContent>
                        {Object.values(product.config).map((item) => {
                            if (item.variant === "None") return null;
                            return (
                                <Grid container key={item}>
                                    <StyledTypographyFilter bold={true}>{item.type}:</StyledTypographyFilter>
                                    <StyledTypographyFilter>{item.variant}</StyledTypographyFilter>
                                </Grid>
                            );
                        })}
                    </WrapperSectionContent>
                </>}
                <StyledSection item xs={12}>Розміри та додаткові послуги</StyledSection>

                <StyledTypographyFilter>
                    Введіть розміри підвіконня. Система автоматично підрахує вартість згідно
                    вказаних розмірів.
                </StyledTypographyFilter>
                <Grid mt={2} mb={2}>
                    <TextFieldSelect
                        selectedWidth={selectedWidth}
                        handleWidthChange={handleWidthChange}
                        product={product}
                    />
                    <TextFieldInput
                        selectedLength={selectedLength}
                        handleLengthChange={handleLengthChange}
                        lengthError={lengthError}
                        getSelectedLengthError={getSelectedLengthError}
                        title='введіть довжину в міліметрах:'
                    />
                </Grid>

                <FormGroup>
                    {product?.additionalPrice?.map((item, index) => (
                        <Grid container alignItems="center" key={item._id}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={additionalPriceChecked.some(checkedItem => checkedItem._id === item._id)}
                                        onChange={handleChangeAdditionalPrice}
                                        name={item._id}
                                    />
                                }
                                label={
                                    <Typography sx={{ color: theme.palette.primary.main }}>
                                        {item.additionally}
                                    </Typography>
                                }
                            />
                            <TextFieldInputCount
                                selectedCount={selectedCounts[index]}
                                handleCountChange={(event) => handleCountChange(event, index)}
                                lengthError={lengthError}
                                getSelectedLengthError={getSelectedLengthError}
                                title=""
                            />
                        </Grid>
                    ))}
                </FormGroup>

                <StyledSection item xs={12}>Ціна</StyledSection>
                <Grid container mt={1}>
                    {!isMainState &&
                        <Button startIcon={<ArrowBackIcon />} onClick={handleBackToList}>Продовжити покупки</Button>
                    }
                    {isMainState &&
                        <>
                            <StyledTypographyPrice>
                                {Boolean(lengthError)
                                    ? "0"
                                    : calculateTotalPrice(currentPrice, selectedLength, additionalPriceChecked, selectedCounts)}
                            </StyledTypographyPrice>
                            <StyledCurrency>грн</StyledCurrency>
                        </>
                    }
                    <StyledButtonAddToShoppingCard
                        loading={isLoading}
                        onClick={handleButtonClick}
                        disabled={Boolean(lengthError)}
                        variant="contained"
                        isMainState={isMainState} // передаємо isMainState як пропс
                    >
                        <ShoppingCartIcon sx={{ marginRight: 1 }} /> {buttonText}
                    </StyledButtonAddToShoppingCard>
                </Grid>
            </Grid>
        </ProductBlockContainer>
    );
};